import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetPromoBannerQuery } from "src/api/services/patientApi";
import { theme } from "src/assets/theme";
import { MatchParam } from "src/constants/matches";
import { useCountdown } from "src/hooks/useCountdown";
import { useIsMobile } from "src/hooks/useIsMobile";

interface Props {
  showCountdown?: boolean;
}

const PromoBanner = ({ showCountdown = false }: Props) => {
  const isMobile = useIsMobile();
  const component = "promo-banner";
  const { product } = useParams<MatchParam<"PRODUCT_NAME">>();
  const { i18n } = useTranslation();
  const { data } = useGetPromoBannerQuery(
    product && i18n.language ? { product, lang: i18n.language } : skipToken
  );
  const { t } = useTranslation();

  const countdown = useCountdown({ activate: showCountdown });

  const bannerText = useMemo(() => {
    if (data == null) return "";

    return data.text;
  }, [data]);

  const banner = useMemo(
    () =>
      !showCountdown
        ? bannerText
        : t(`${component}.timer`, {
            countdown,
          }),
    [bannerText, countdown, showCountdown, t]
  );

  return (
    banner && (
      <Stack
        justifyContent="center"
        alignItems="center"
        p={1}
        sx={{
          background: !showCountdown
            ? "var(--Primary-Primary-100, #CCF6F7)"
            : theme.palette.secondary.main,
          height: "50px",
        }}
      >
        <Typography
          textAlign="center"
          fontWeight={700}
          variant={isMobile ? "body1" : "h6"}
          color={!showCountdown ? "#000000" : "#FFFFFF"}
        >
          {banner}
        </Typography>
      </Stack>
    )
  );
};

export default PromoBanner;
